import * as React from "react";

const UploadCloudIcon = (props) => (
	<svg
		width={33}
		height={32}
		viewBox="0 0 33 32"
		fill="none"
		xmlns="http://www.w3.org/2000/svg"
		{...props}
	>
		<g
			clipPath="url(#a)"
			stroke="#647DFF"
			strokeWidth={2}
			strokeLinecap="round"
			strokeLinejoin="round"
		>
			<path d="M21.583 21.333 16.25 16l-5.333 5.333M16.25 16v12"/>
			<path
				d="M27.437 24.52A6.666 6.666 0 0 0 24.25 12h-1.68A10.665 10.665 0 0 0 3.63 8.378a10.67 10.67 0 0 0 .62 13.356"/>
			<path d="M21.583 21.333 16.25 16l-5.333 5.333"/>
		</g>
		<defs>
			<clipPath id="a">
				<path fill="#fff" d="M.25 0h32v32h-32z"/>
			</clipPath>
		</defs>
	</svg>
);
export default UploadCloudIcon;
